export const CREATE_CHANNEL = 'Create Channel';
export const CREATE_DM = 'Create Direct Message';
export const BROWSE_PUBLIC_CHANNELS = 'Browse Public Channels';

/* --------- Sidebar Empty State Messages --------------*/
export const SIDEBAR_NO_CHANNELS = 'You are not currently a part of any channels. Start a new one or browse through public channels.';
export const SIDEBAR_NO_CHANNELS_FILTER = 'No channels found as part of your filter criteria. Start a new one or browse through public channels.';
export const SIDEBAR_NO_DMS = 'Would you like to start a new conversation?';
export const SIDEBAR_NO_DMS_FILTER = 'No direct messages found. Would you like to start a new conversation?';
/*-----------------------------------------------------*/

/* --------- Browse Panel Empty State Messages ---------*/
export const NO_RESULTS_FOUND = 'No results found';
export const EMPTY_STATE_FILTER_CHANNELS_FILTERTERM_LINE1 = 'There are no results that match your search criteria.';
export const EMPTY_STATE_FILTER_CHANNELS_FILTERTERM_LINE2 = 'Would you like to create a new channel?';
export const EMPTY_STATE_FILTER_CHANNELS_NO_FILTERTERM_LINE1 = 'Looks like your organization currently does not have any channels.';
export const EMPTY_STATE_FILTER_CHANNELS_NO_FILTERTERM_LINE2 = 'Be the first to create one!';
export const EMPTY_STATE_FILTER_CHANNELS = 'There are no results that match your search criteria.';
export const EMPTY_STATE_FILTER_PEOPLE = 'Consider broadening your search or filter criteria.';
/*-----------------------------------------------------*/

/* -------------------- Create Panel -------------------*/
export const START_CONVERSATION = 'Find or start a conversation';
export const GO = 'GO';
/*-----------------------------------------------------*/

/* --------------------- Chat Panel --------------------*/
export const CHANNEL_DOESNT_EXIST = 'This channel either doesn\'t exist or is a private channel.';
/*-----------------------------------------------------*/

/* --------------- Send to Inbox Toasts  ---------------*/
export const SEND_TO_INBOX_SENDING_TOAST_PREFIX = 'Sending';
export const SEND_TO_INBOX_SENDING_TOAST_SINGULAR_ITEM = 'item';
export const SEND_TO_INBOX_SENDING_TOAST_PLURAL_ITEM = 'items';
export const SEND_TO_INBOX_SENDING_TOAST_SUFFIX = 'to the practice inbox';
export const SEND_TO_INBOX_RESULT_TOAST_FAIL_PREFIX = 'Failed to send';
export const SEND_TO_INBOX_RESULT_TOAST_SUCCESS_PREFIX = 'Successfully sent';
export const SEND_TO_INBOX_RESULT_TOAST_EXPORT = 'your export from';
export const SEND_TO_INBOX_RESULT_TOAST_DM = 'your chat with';
export const SEND_TO_INBOX_RESULT_TOAST_CHANNEL = 'channel';
/*-----------------------------------------------------*/
